import component from './de-DE/component';
import globalHeader from './de-DE/globalHeader';
import menu from './de-DE/menu';
import pages from './de-DE/pages';
import pwa from './de-DE/pwa';
import settingDrawer from './de-DE/settingDrawer';
import settings from './de-DE/settings';
import fixOverlay from './de-DE/fix_overlay';
import fixOpenapi from './de-DE/fix_openapi';
import fixAdminMisc from './de-DE/fix_adminmisc';
import fixBilling from './de-DE/fix_billing';
import fixComponents from './de-DE/fix_components';
import fixConsoleMisc from './de-DE/fix_consolemisc';
import fixGap from './de-DE/fix_gap';
import fixSystemconfig from './de-DE/fix_systemconfig';
import fixTenant from './de-DE/fix_tenant';
import fixVoiceClone from './de-DE/fix_voiceclone';
import fixTodo from './de-DE/fix_todo';
import fixLedger from './de-DE/fix_ledger';


export default {
  'navBar.lang': 'Sprache',
  'layout.user.link.help': 'Hilfe',
  'layout.user.link.privacy': 'Datenschutz',
  'layout.user.link.terms': 'Bedingungen',
  'app.preview.down.block': 'Diese Seite in das lokale Projekt herunterladen',
  'app.welcome.link.fetch-blocks': 'Abrufen aller Bl?cke',
  'app.welcome.link.block-list': 'Erstellen Sie schnell standardisierte Seiten basierend auf dem Blockentwicklungsframework',
  ...fixConsoleMisc,
  ...fixComponents,
  ...fixAdminMisc,
  ...fixBilling,
  ...fixTenant,
  ...fixVoiceClone,
  ...fixGap,
  ...fixSystemconfig,
  ...fixOpenapi,
  ...fixTodo,
  ...fixLedger,
};
